import React, { useLayoutEffect } from 'react'
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from './Layout/Header';
import Footer from './Layout/Footer';
import NotFound from './Component/NotFound/NotFound';
import Category from './Component/Category/Category';
import CategoryDynamic from './Component/Category/CategoryDynamic';
import Products from './Component/Products/Products';
import {Custom} from './Helpers/ThemeCustomization'
import {ConfigProvider} from 'antd'
import AllProducts from './Component/Products/AllProducts';

const App = () => {
  const Wrapper = ({ children }) => {
    const location = useLocation();
    useLayoutEffect(() => {
      document.documentElement.scrollTo(500, 0);
    }, [location.pathname]);
    return children;
  };
  return (
    <>
    <ConfigProvider
        theme={{
          token: Custom,
        }}
      >
      <BrowserRouter basename='/our-product'>
        <Wrapper>
          <Header />
          <Routes>
            <Route index element={<Category />} />
            <Route exact path="category" element={<Category />} />
            <Route exact path='products' element={<AllProducts />} />
            <Route path="product/:id" element={<Products />} />
            <Route path="category/:id" element={<CategoryDynamic />} />
            <Route path="category/:id/:id" element={<CategoryDynamic />} />
            <Route path="category/:id/:id/:id" element={<CategoryDynamic />} />
            <Route path="category/:id/:id/:id/:id" element={<CategoryDynamic />} />
            <Route path="category/:id/:id/:id/:id/:id" element={<CategoryDynamic />} />
            <Route path="category/:id/:id/:id/:id/:id/:id" element={<CategoryDynamic />} />
            <Route path="category/:id/:id/:id/:id/:id/:id/:id" element={<CategoryDynamic />} />
            <Route path="category/:id/:id/:id/:id/:id/:id/:id/:id" element={<CategoryDynamic />} />
            <Route path="category/:id/:id/:id/:id/:id/:id/:id/:id/:id" element={<CategoryDynamic />} />
            <Route path="category/:id/:id/:id/:id/:id/:id/:id/:id/:id/:id" element={<CategoryDynamic />} />
            <Route path="category/:id/:id/:id/:id/:id/:id/:id/:id/:id/:id/:id" element={<CategoryDynamic />} />
            <Route path="category/:id/:id/:id/:id/:id/:id/:id/:id/:id/:id/:id/:id" element={<CategoryDynamic />} />
            <Route path="category/:id/:id/:id/:id/:id/:id/:id/:id/:id/:id/:id/:id/:id" element={<CategoryDynamic />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <Footer />
        </Wrapper>
      </BrowserRouter>
      </ConfigProvider>
    </>
  )
}

export default App